import FalconCloseButton from 'components/common/FalconCloseButton';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from '../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';


const ModalDesactivarLicencia = ({
    showModalDesactivar,
    setShowModalDesactivar,
    licencias,
    idLicencia,
    setPolizasRelacionadas
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { register, reset, handleSubmit, formState: { errors } } = useForm();
    const [procesandoModal, setProcesandoModal] = useState(false);

    /**
    * Submit de desactivar
    * @param {any} data
    */
    const onSubmitDesactivar = data => {
        setProcesandoModal(true);
        desactivarLicencia(JSON.stringify(data));

    };

    /**
     * Desactivar Licencia
     */
    const desactivarLicencia = async () => {
        const response = await fetch("/api/licencia/desactivarlicencia/?id=" + idLicencia, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {
               // getInformacionDetalladaLicenciaByID();
                showSuccessToast(data["table1"][0].vMessage);

                //se actualizan unicamente los campos modificados.
                licencias.bIsPeriodoPrueba = data["table2"][0].bIsPeriodoPrueba;
                licencias.dUpdatedDate = data["table2"][0].dUpdatedDate;
                licencias.vUpdatedUser = data["table2"][0].vUpdatedUser;
                licencias.dInicioLicenciaUso = data["table2"][0].dInicioLicenciaUso;
                licencias.dDiasTranscurridos = data["table2"][0].dDiasTranscurridos;
                licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
                licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;
                licencias.idCatCicloFacturacion = data["table2"][0].idCatCicloFacturacion;
                licencias.vLatLon = data["table2"][0].vLatLon;
                licencias.vConfiguracion = data["table2"][0].vConfiguracion;
                setPolizasRelacionadas(data["table3"]);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalDesactivar(false);
        setProcesandoModal(false);
        reset();
    };


    return (
        showModalDesactivar &&
        <Modal
            show={showModalDesactivar}
            onHide={() => setShowModalDesactivar(false)}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitDesactivar)}>
                <Modal.Header>
                    <Modal.Title>Desactivar Licencia {licencias.vDescripcionTipo}</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalDesactivar(false); reset() }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <h5>&#191;Est&aacute; seguro que desea desactivar la licencia?</h5>
                        <p>La licencia cambiar&aacute; a un estado de <SoftBadge pill bg='danger' className='me-2'>PERIODO DE PRUEBA</SoftBadge> Ser&aacute; posible activarla nuevamente pero debes considerar que las p&oacute;lizas vinculadas a esta licencia se cancelar&aacute;n. </p>
                    </Row>
                    <Form.Group className="mb-3" >
                        <Form.Label>Escribe: DESACTIVAR</Form.Label>
                        <Form.Control
                            type="text"
                            autoComplete="off"
                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                            isInvalid={!!errors.vConfirmacion}
                            {...register("vConfirmacion",
                                {
                                    required: 'Es necesario que escribas: DESACTIVAR',
                                    pattern: /DESACTIVAR$/
                                })
                            }
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.vConfirmacion && errors.vConfirmacion.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalDesactivar(false); reset() }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='danger' >D E S A C T I V A R</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalDesactivarLicencia.propTypes = {
    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    showModalDesactivar: PropTypes.bool,
    setShowModalDesactivar: PropTypes.func,
    setPolizasRelacionadas: PropTypes.func
};


export default ModalDesactivarLicencia;